import { Card, Typography } from "@mui/material";
import { ToolInfoDto } from "../api/models/ToolInfoDto";
import AdminToolButton from "./AdminToolButton";
import styles from "./AdminToolFilter.module.scss";

interface AdminToolFilterProps {
  onSelect: (tool: ToolInfoDto) => void;
  selectedToolKey: string | null;
  tools: ToolInfoDto[];
}

const AdminToolFilter = ({
  onSelect,
  selectedToolKey,
  tools,
}: AdminToolFilterProps): JSX.Element => {
  return (
    <Card className={styles.adminToolFilter}>
      <div className={styles.adminToolFilter__content}>
        {tools.map((t) => (
          <AdminToolButton
            key={t.capabilityToolKey}
            toolKey={t.capabilityToolKey}
            toolName={t.toolName}
            toolDisplayName={t.toolDisplayName}
            isSelected={selectedToolKey === t.capabilityToolKey}
            onSelect={() => onSelect(t)}
          />
        ))}
      </div>
    </Card>
  );
};

export default AdminToolFilter;
